const types = {
  //Get Request List
  GET_REQUEST_START: "GET_REQUEST_START",
  GET_REQUEST_SUCCESS: "GET_REQUEST_SUCCESS",
  GET_REQUEST_ERROR: "GET_REQUEST_ERROR",
  GET_REQUEST_RESET: "GET_REQUEST_RESET",

  //Create Request
  CREATE_REQUEST_START: "CREATE_REQUEST_START",
  CREATE_REQUEST_SUCCESS: "CREATE_REQUEST_SUCCESS",
  CREATE_REQUEST_ERROR: "CREATE_REQUEST_ERROR",
  CREATE_REQUEST_RESET: "CREATE_REQUEST_RESET",

  //Update Request
  UPDATE_REQUEST_START: "UPDATE_REQUEST_START",
  UPDATE_REQUEST_SUCCESS: "UPDATE_REQUEST_SUCCESS",
  UPDATE_REQUEST_ERROR: "UPDATE_REQUEST_ERROR",
  UPDATE_REQUEST_RESET: "UPDATE_REQUEST_RESET",

  //Delete Request
  DELETE_REQUEST_START: "DELETE_REQUEST_START",
  DELETE_REQUEST_SUCCESS: "DELETE_REQUEST_SUCCESS",
  DELETE_REQUEST_ERROR: "DELETE_REQUEST_ERROR",
  DELETE_REQUEST_RESET: "DELETE_REQUEST_RESET",

  //Single Request
  SINGLE_REQUEST_START: "SINGLE_REQUEST_START",
  SINGLE_REQUEST_SUCCESS: "SINGLE_REQUEST_SUCCESS",
  SINGLE_REQUEST_ERROR: "SINGLE_REQUEST_ERROR",
  SINGLE_REQUEST_RESET: "SINGLE_REQUEST_RESET",
};

export default types;

